import { FC, SVGProps } from 'react'

import { IconPack } from './enum'
import * as Icons from './svgs'

export interface Props extends SVGProps<SVGSVGElement> {
  name: IconPack
}

/**
 * Cell 패키지가 생기기 이전에 사용하던 Icon 컴포넌트입니다.
 *
 * 이 컴포넌트는 deprecated 되어야 하며, cell의 아이콘이 필요할 때에는 cell-icon 패키지를 사용해주세요.
 *
 * cell에 없는 새 Icon을 추가할 때에는 /components/atomic/atoms/CheetahIcon에 추가해주세요.
 */
const Icon: FC<Props> = ({ name, ...svgProps }): JSX.Element | null => {
  const SvgIcon = Icons[name]

  if (!SvgIcon) {
    return null
  }

  return (
    <>
      <SvgIcon {...svgProps} />
    </>
  )
}

export default Icon
